import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserService } from 'src/app/services/user.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit{

  clients: any[] = []; //Información básica los clientes
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string =""; //Mensaje de error
  displayedColumns: string[] = ['email', 'user_fullname', 'cliente', 'pro_id', 'created_at', 'updated_at', 'user_status', 'operaciones'];
  dataSource :any;
  usersData: any []= []; //Información de los clientes
  tiempoEsperaRecarga: number = 60000; //Despues del error 429 se esperan 60 segundos para recargar la página
  numeroUsuarios: number = 0;
  pageSizeOptions: number[] = [10, 20, this.numeroUsuarios];
  users: any = [];
  userData: any = [];

  //PAGINACIÓN
  currentPage: number = 0;
  currentPageSize: number = 20;
  totalItems: number = 300;
  sizeOptions: number[] = [10, 20, 30];

  private usersSubscription: Subscription | undefined;
  private clientesSubscription: Subscription | undefined;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private userService: UserService, private router: Router, private error429: Error429Service, private userDataService: UserDataService){
    this.userData = this.userDataService.getUserData();
  }
  
  ngOnInit(): void {
    this.usersSubscription = this.userService.getUsers().subscribe({
      next:resp =>{
        this.users = resp;
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.clientesSubscription = this.userService.getClients().subscribe({
          next:resp =>{
            this.clients = resp;
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete:()=>{
            console.log(this.users);
            for(let i=0; i<this.users.length; i++){
              let userProId = "No encontrado";
              if(this.users[i].pro_id == 4){
                userProId = "Super usuario root";
              }
              if(this.users[i].pro_id == 1){
                userProId = "Administrador";
              }
              if(this.users[i].pro_id == 2){
                userProId = "Hostelero";
              }
              if(this.users[i].pro_id == 3){
                userProId = "Consumidor";
              }
              this.usersData.push({
                id: this.users[i].id,
                email: this.users[i].email,
                user_fullname: this.users[i].user_fullname,
                created_at: this.users[i].created_at,
                updated_at: this.users[i].updated_at,
                cliente: this.obtenerNombreCliente(this.users[i].cliente_id),
                user_status: this.users[i].user_status,
                pro_id: userProId,
              });
            }
            this.dataSource = new MatTableDataSource(this.usersData); 
            this.dataSource.filterPredicate = (data: any, filter: string) => {
              const dataStr = this.displayedColumns
                .filter(key => key !== 'id')
                .map(key => data[key])
                .join('')
                .toLowerCase();
          
              return dataStr.includes(filter);
            };
            this.datosRecibidos = true; 
            setTimeout(() => {
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
            },0)
          }
        })
      }
    });
  }

  ocultarBoton(element: any): boolean {
  return this.userData.pro_id === 1 && element.pro_id === 'Super usuario root';
}


  obtenerNombreCliente(id: number): string {
    const cliente = this.clients.find((cliente:any) => cliente && cliente.id === id);
    return cliente ? cliente.razon_social : 'Cliente no encontrada';
  }

  ngOnDestroy(): void {
    if (this.usersSubscription) {
      this.usersSubscription.unsubscribe();
    }
    if (this.clientesSubscription) {
      this.clientesSubscription.unsubscribe();
    }
  }

  pageChanged(event: any) {
    this.currentPage = event.pageIndex;
    this.currentPageSize = event.pageSize;
  }


  //Función para convertir la fecha
  formatDateTime(dateTimeString: string | null): string {
    if (dateTimeString !== null) {
      const inputDate = new Date(dateTimeString);
      const year = inputDate.getFullYear();
      const month = ('0' + (inputDate.getMonth() + 1)).slice(-2);
      const day = ('0' + inputDate.getDate()).slice(-2);
      const hours = ('0' + inputDate.getHours()).slice(-2);
      const minutes = ('0' + inputDate.getMinutes()).slice(-2);
      const seconds = ('0' + inputDate.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return '';
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  descargarExcel(){
    console.log(this.usersData);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Email', key: 'email', width: 10 },
      { header: 'Nombre', key: 'user_fullname', width: 30 },
      { header: 'Cliente', key: 'razon_social', width: 30 },
      { header: 'Tipo', key: 'pro_id', width: 15 },
      { header: 'Fecha de alta', key: 'created_at', width: 25 },
      { header: 'Modificado', key: 'updated_at', width: 25 },
      { header: 'Estado', key: 'estado', width: 15 },
    ];
    /*this.devicesAndEstablishmentInfo.forEach(establecimiento => {
      worksheet.addRow(establecimiento);
    });*/
    this.usersData.forEach(user => {
      const formattedUser = {
        email: user.email,
        user_fullname: user.user_fullname,
        razon_social: user.cliente,
        created_at: this.formatDateTime(user.created_at),
        updated_at: this.formatDateTime(user.updated_at),
        estado: user.user_status === 1 ? 'activo' : 'desactivado',
        pro_id: user.pro_id,
      };
      const row = worksheet.addRow(formattedUser);
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const columnWidth = cell.text.length + 3;
        const currentColumn = worksheet.getColumn(colNumber);
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado usuarios DataBeer.xlsx');
    });
  }

}
